/* fish-cart.js — self-contained lander cart/bundle logic.
   No dependency on theme JS (cleantt core JS ships from a third-party CDN
   we can't read); cart drawer is touched at DOM level only. */
(function () {
  'use strict';

  /* multiple sections include this file; every <script> executes, so double
     event-binding (e.g. drawer toggling twice per click) must be guarded */
  if (window.__fishCartInit) return;
  window.__fishCartInit = true;

  var NUL = ' ';
  var fmt = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };
  var norm = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
  /* variant image URLs in the vm JSON are raw 2048px masters; request a CDN
     transform sized for chips/thumbs or mobile pays MBs for 40px images */
  var thumbUrl = function (src, w) {
    if (!src) return src;
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  };

  /* ---------------- bundle ---------------- */

  function FishBundle() { return Reflect.construct(HTMLElement, [], FishBundle); }
  FishBundle.prototype = Object.create(HTMLElement.prototype);
  FishBundle.prototype.constructor = FishBundle;

  FishBundle.prototype.connectedCallback = function () {
    if (this._fishInitialized) return;
    var vm = document.getElementById('fish-vm-' + this.dataset.sectionId);
    if (!vm) return;
    var data = JSON.parse(vm.textContent);
    this._fishInitialized = true;
    this.opts = data.opts;
    this.variants = data.v;
    this.productImg = data.pimg || '';
    this.byKey = {};
    for (var i = 0; i < data.v.length; i++) {
      var v = data.v[i];
      this.byKey[norm(v.o1) + NUL + norm(v.o2) + NUL + norm(v.o3)] = v;
    }
    this.o1Values = uniq(data.v.map(function (v) { return v.o1; }));
    this.o2Values = uniq(data.v.map(function (v) { return v.o2; }));
    this.o3Values = uniq(data.v.map(function (v) { return v.o3; }));
    this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-tier]'));
    this.cta = this.querySelector('[data-cta]');
    this.state = null;

    var self = this;
    this.tiers.forEach(function (tier, idx) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('.fish-pill')) return;
        self.selectTier(idx);
      });
      tier.addEventListener('keydown', function (e) {
        if (e.target.closest('.fish-pill')) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.selectTier(idx); }
      });
    });
    this.cta.addEventListener('click', function () { self.submit(); });

    var def = parseInt(this.dataset.defaultTier || '2', 10) - 1;
    this.selectTier(Math.min(Math.max(def, 0), this.tiers.length - 1));
  };

  function uniq(arr) {
    var seen = {}, out = [];
    arr.forEach(function (x) {
      var k = norm(x);
      if (k !== '' && !seen[k]) { seen[k] = 1; out.push(x); }
    });
    return out;
  }

  FishBundle.prototype.selectTier = function (idx) {
    var self = this;
    this.tierIdx = idx;
    var tier = this.tiers[idx];
    var qty = parseInt(tier.dataset.qty, 10) || 1;
    this.state = { qty: qty, slots: [] };
    for (var s = 0; s < qty; s++) {
      var o1 = s > 0 ? this.state.slots[s - 1].o1 : this.defaultO1();
      var o2 = this.defaultO2(o1);
      this.state.slots.push({ o1: o1, o2: o2, o3: this.defaultO3(o1, o2) });
    }
    /* each tier keeps its own picks (owner 2026-10-03): reopening a tier restores what was chosen there */
    this.tierPicks = this.tierPicks || {};
    if (this.tierPicks[idx] && this.tierPicks[idx].length === qty) this.state.slots = JSON.parse(JSON.stringify(this.tierPicks[idx]));
    this.tiers.forEach(function (t, i) {
      t.classList.toggle('is-selected', i === idx);
      t.setAttribute('aria-checked', i === idx ? 'true' : 'false');
      var slots = t.querySelector('[data-slots]');
      slots.hidden = i !== idx;
      if (i === idx) self.renderSlots(slots);
    });
    this.update();
  };

  FishBundle.prototype.defaultO1 = function () {
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].a) return this.variants[i].o1;
    }
    return this.o1Values[0];
  };

  /* preselect a size so every tier starts checkout-ready: prefer M, else
     first available size for the given color */
  FishBundle.prototype.defaultO2 = function (o1) {
    if (!this.o2Values.length) return null;
    var self = this;
    var avail = this.o2Values.filter(function (o2) {
      return self.variants.some(function (v) { return norm(v.o1) === norm(o1) && norm(v.o2) === norm(o2) && v.a; });
    });
    if (!avail.length) return null;
    for (var i = 0; i < avail.length; i++) {
      if (norm(avail[i]) === 'm') return avail[i];
    }
    return avail[0];
  };

  FishBundle.prototype.defaultO3 = function (o1, o2) {
    if (!this.o3Values.length) return null;
    var avail = this.variants.filter(function (v) {
      return norm(v.o1) === norm(o1) && norm(v.o2) === norm(o2) && v.a;
    });
    var preferred = avail.find(function (v) { return norm(v.o3) === 'm'; });
    return preferred ? preferred.o3 : (avail[0] ? avail[0].o3 : null);
  };

  FishBundle.prototype.renderSlots = function (mount) {
    var self = this;
    mount.innerHTML = '';
    this.state.slots.forEach(function (slot, si) {
      var el = document.createElement('div');
      el.className = 'fish-slot';
      var ttl = document.createElement('div');
      ttl.className = 'fish-slot__title';
      ttl.dataset.slotTitle = si;
      el.appendChild(ttl);

      var thumb = document.createElement('img');
      thumb.className = 'fish-slot__thumb';
      thumb.alt = '';
      thumb.loading = 'lazy';
      thumb.dataset.slotThumb = si;
      el.appendChild(thumb);

      var pickers = document.createElement('div');
      pickers.className = 'fish-slot__pickers';
      pickers.appendChild(self.pillRow(self.opts[0], self.o1Values, si, 'o1'));
      if (self.o2Values.length) pickers.appendChild(self.pillRow(self.opts[1], self.o2Values, si, 'o2'));
      if (self.o3Values.length) pickers.appendChild(self.pillRow(self.opts[2], self.o3Values, si, 'o3'));
      el.appendChild(pickers);

      mount.appendChild(el);
    });
  };

  FishBundle.prototype.imgFor = function (o1) {
    for (var i = 0; i < this.variants.length; i++) {
      if (norm(this.variants[i].o1) === norm(o1) && this.variants[i].img) {
        return this.variants[i].img;
      }
    }
    return '';
  };

  FishBundle.prototype.pillRow = function (optName, values, si, dim) {
    var self = this;
    var row = document.createElement('div');
    row.className = 'fish-slot__row fish-slot__row--' + dim;
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', optName + ' for item ' + (si + 1));
    values.forEach(function (val) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fish-pill fish-pill--' + dim;
      b.dataset.slot = si;
      b.dataset.dim = dim;
      b.dataset.val = val;
      var img = dim === 'o1' ? self.imgFor(val) : '';
      if (img) {
        /* variant-thumbnail chip: image + tiny name so SKZ/NJZ is readable */
        b.classList.add('fish-pill--thumb');
        b.title = val;
        b.setAttribute('aria-label', val);
        var im = document.createElement('img');
        im.src = thumbUrl(img, 120);
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
        var nm = document.createElement('span');
        nm.className = 'fish-pill__name';
        nm.textContent = String(val).replace(/\s*-\s*Hoodie$/i, '');
        b.appendChild(nm);
      } else {
        b.appendChild(document.createTextNode(val));
      }
      b.addEventListener('click', function () {
        self.state.slots[si][dim] = val;
        if (dim === 'o1') {
          var selected = self.resolve(self.state.slots[si]);
          if (!selected || !selected.a) {
            self.state.slots[si].o2 = self.defaultO2(val);
            self.state.slots[si].o3 = self.defaultO3(val, self.state.slots[si].o2);
          }
        }
        if (dim === 'o2' && self.o3Values.length) {
          var selected3 = self.resolve(self.state.slots[si]);
          if (!selected3 || !selected3.a) self.state.slots[si].o3 = self.defaultO3(self.state.slots[si].o1, val);
        }
        self.update();
      });
      row.appendChild(b);
    });
    return row;
  };

  FishBundle.prototype.resolve = function (slot) {
    if (slot.o1 == null) return null;
    if (this.o2Values.length && slot.o2 == null) return null;
    if (this.o3Values.length && slot.o3 == null) return null;
    return this.byKey[norm(slot.o1) + NUL + norm(slot.o2) + NUL + norm(slot.o3)] || null;
  };

  FishBundle.prototype.availFor = function (slot, dim, val) {
    return this.variants.some(function (v) {
      if (!v.a) return false;
      if (dim === 'o1') return norm(v.o1) === norm(val);
      if (norm(v.o1) !== norm(slot.o1)) return false;
      if (dim === 'o2') return norm(v.o2) === norm(val);
      return norm(v.o2) === norm(slot.o2) && norm(v.o3) === norm(val);
    });
  };

  FishBundle.prototype.pricing = function () {
    var tier = this.tiers[this.tierIdx];
    var type = tier.dataset.offerType || 'none';
    var value = parseFloat(tier.dataset.offerValue || '0') || 0;
    var resolved = this.state.slots.map(this.resolve, this);
    var complete = resolved.every(function (v) { return v && v.a; });
    var base = 0, compare = 0, prices = [];
    resolved.forEach(function (v, i) {
      var p = v ? v.p : 0;
      base += p;
      compare += v ? (v.c > 0 ? v.c : v.p) : 0;
      prices.push(p);
    });
    var total = base;
    if (type === 'fixed_per_item') total = base - Math.round(value * 100) * this.state.qty;
    else if (type === 'percent') { var pOff = 0; prices.filter(Boolean).forEach(function (pp) { pOff += Math.floor(pp * value / 100); }); total = base - pOff; }
    else if (type === 'bogo_50' && prices.length >= 2) {
      total = base - Math.floor(Math.min.apply(null, prices.filter(Boolean)) / 2);
    }
    if (total < 0) total = 0;
    return { complete: complete, resolved: resolved, total: total, base: base, compare: Math.max(compare, base) };
  };

  FishBundle.prototype.update = function () {
    var self = this;
    var p = this.pricing();

    var slotsEl = this.tiers[this.tierIdx].querySelector('[data-slots]');
    if (slotsEl) {
      Array.prototype.forEach.call(slotsEl.querySelectorAll('.fish-pill'), function (b) {
        var si = +b.dataset.slot, dim = b.dataset.dim, val = b.dataset.val;
        b.classList.toggle('is-active', norm(self.state.slots[si][dim]) === norm(val));
        var ok = self.availFor(self.state.slots[si], dim, val);
        b.disabled = !ok;
        b.classList.toggle('is-oos', !ok);
        // Show only option values that exist for this item; sold-out sizes remain visible.
        var slot = self.state.slots[si];
        var exists = dim === 'o1' || self.variants.some(function (v) {
          if (norm(v.o1) !== norm(slot.o1)) return false;
          if (dim === 'o2') return norm(v.o2) === norm(val);
          return norm(v.o2) === norm(slot.o2) && norm(v.o3) === norm(val);
        });
        b.hidden = !exists;

      });
      Array.prototype.forEach.call(slotsEl.querySelectorAll('[data-slot-title]'), function (t) {
        var si = +t.dataset.slotTitle, s = self.state.slots[si];
        var pick = [s.o1, s.o2, s.o3].filter(function (x) { return x != null && x !== ''; }).join(' / ');
        var n = self.state.slots.length;
        t.innerHTML = '';
        t.appendChild(document.createTextNode(n > 1 ? 'Item ' + (si + 1) + ' ' : 'Selected '));
        var sp = document.createElement('span'); sp.textContent = pick ? '— ' + pick : ''; t.appendChild(sp);
      });
      Array.prototype.forEach.call(slotsEl.querySelectorAll('[data-slot-thumb]'), function (img) {
        var si = +img.dataset.slotThumb;
        var v = self.resolve(self.state.slots[si]);
        var src = (v && v.img) || self.imgFor(self.state.slots[si].o1) ||
                  self.productImg || '';
        if (src) {
          img.src = thumbUrl(src, 160);
          img.hidden = false;
        } else {
          /* nothing to show at all — hide rather than render a srcless box */
          img.removeAttribute('src');
          img.hidden = true;
        }
      });
    }

    /* tier thumbnails show the variants picked for that tier (owner 2026-10-03): Buy 1 = the chosen variant,
       Buy 2/3 = each chosen variant; tiers not open yet repeat Item 1's pick */
    this.tiers.forEach(function (tier, ti) {
      var box = tier.querySelector('.fish-tier__img'); if (!box) return;
      var q = Math.min(+tier.dataset.qty || 1, 3), srcs = [];
      self.tierPicks = self.tierPicks || {};
      if (ti === self.tierIdx) self.tierPicks[ti] = JSON.parse(JSON.stringify(self.state.slots));
      var picks = self.tierPicks[ti];
      for (var k = 0; k < q; k++) {
        var sl = picks ? picks[k] : null;
        if (!sl) { var d1 = self.defaultO1(), d2 = self.defaultO2(d1); sl = { o1: d1, o2: d2, o3: self.defaultO3(d1, d2) }; }
        var vv = sl ? self.resolve(sl) : null;
        srcs.push((vv && vv.img) || (sl && self.imgFor(sl.o1)) || self.productImg || '');
      }
      var key = srcs.join('|'); if (box.dataset.k === key) return; box.dataset.k = key;
      box.innerHTML = ''; box.classList.toggle('is-multi', srcs.length > 1);
      box.style.setProperty('--n', srcs.length);
      srcs.forEach(function (s) { if (!s) return; var im = document.createElement('img'); im.src = thumbUrl(s, 140); im.alt = ''; im.loading = 'lazy'; box.appendChild(im); });
    });

    this.tiers.forEach(function (tier, i) {
      /* incomplete selection must show the estimate, never a $0.00 sum */
      var probe = (i === self.tierIdx && p.complete) ? p : self.estimate(tier);
      var priceEl = tier.querySelector('[data-tier-price]');
      var cmpEl = tier.querySelector('[data-tier-compare]');
      if (priceEl) priceEl.textContent = (probe.approx ? 'from ' : '') + fmt(probe.total);
      if (cmpEl) cmpEl.textContent = probe.compare > probe.total ? fmt(probe.compare) : '';
      var saveEl = tier.querySelector('[data-tier-save]');
      if (saveEl) {
        var saved = probe.compare - probe.total;
        saveEl.hidden = saved <= 0;
        if (saved > 0) saveEl.textContent = 'You save $' + Math.floor(saved / 100).toLocaleString('en-US');
      }
      var eachEl = tier.querySelector('[data-tier-each]');
      if (eachEl) {
        var q = +tier.dataset.qty || 1;
        eachEl.hidden = q < 2;
        if (q >= 2) eachEl.textContent = fmt(Math.round(probe.total / q)) + ' each';
      }
    });

    var labelEl = this.querySelector('[data-cta-label]');
    if (!this.ctaText) this.ctaText = labelEl.textContent.trim() || 'Add to cart';
    this.cta.disabled = !p.complete;
    labelEl.textContent = p.complete
      ? this.ctaText
      : 'Select your ' + (this.opts[1] || 'options').toLowerCase();
    this.querySelector('[data-cta-price]').textContent = p.complete ? fmt(p.total) : '';

    this.dispatchEvent(new CustomEvent('fish:bundle-state', {
      bubbles: true,
      detail: { complete: p.complete, total: p.total, compare: p.compare, sectionId: this.dataset.sectionId }
    }));
  };

  /* true when available variants span more than one price */
  FishBundle.prototype.priceVaries = function () {
    if (this._varies === undefined) {
      var seen = null;
      this._varies = false;
      for (var i = 0; i < this.variants.length; i++) {
        if (!this.variants[i].a) continue;
        if (seen === null) seen = this.variants[i].p;
        else if (this.variants[i].p !== seen) { this._varies = true; break; }
      }
    }
    return this._varies;
  };

  /* Full-price estimate for unselected tiers.
     Prices off the customer's CURRENT selection, falling back to the first
     available variant only when nothing is selected yet. Anchoring on
     variants[0] misquotes every mixed-price product: a Tour Collection card
     would quote 2x$24.99 (hoodie) while a shopper picking $19.99 tees is
     charged $10 less than the tier card promised. */
  FishBundle.prototype.estimate = function (tier) {
    var qty = parseInt(tier.dataset.qty, 10) || 1;
    var type = tier.dataset.offerType || 'none';
    var value = parseFloat(tier.dataset.offerValue || '0') || 0;
    var unit = 0, cmp = 0;
    var sel = (this.state && this.state.slots && this.state.slots.length)
      ? this.resolve(this.state.slots[0]) : null;
    /* item chosen but size not yet — still quote THAT item, not the cheapest */
    if (!sel && this.state && this.state.slots && this.state.slots[0] &&
        this.state.slots[0].o1) {
      var want = norm(this.state.slots[0].o1);
      for (var j = 0; j < this.variants.length; j++) {
        if (this.variants[j].a && norm(this.variants[j].o1) === want) { sel = this.variants[j]; break; }
      }
    }
    if (sel) {
      unit = sel.p;
      cmp = sel.c > 0 ? sel.c : unit;
    } else {
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].a) { unit = this.variants[i].p; cmp = this.variants[i].c > 0 ? this.variants[i].c : unit; break; }
      }
    }
    var base = unit * qty, total = base;
    if (type === 'fixed_per_item') total = base - Math.round(value * 100) * qty;
    else if (type === 'percent') total = base - Math.floor(unit * value / 100) * qty;
    else if (type === 'bogo_50' && qty >= 2) total = base - Math.floor(unit / 2);
    /* Mixed-price product with nothing chosen yet: any single number is wrong for
       some selection, so mark it a floor and let the UI render "from $X". */
    return { total: Math.max(total, 0), compare: Math.max(cmp * qty, base),
             approx: !sel && this.priceVaries() };
  };

  FishBundle.prototype.submit = function () {
    var p = this.pricing();
    if (!p.complete) return;
    var tier = this.tiers[this.tierIdx];
    var code = tier.dataset.discountCode || '';
    var counts = {};
    p.resolved.forEach(function (v) { counts[v.i] = (counts[v.i] || 0) + 1; });
    var mode = this.dataset.checkoutMode || 'checkout';
    var items = Object.keys(counts).map(function (id) { return id + ':' + counts[id]; }).join(',');

    if (mode === 'cart') {
      /* ajax add + open the theme's own cart drawer (falls back to /cart page) */
      this.addViaAjax(counts, code);
      return;
    }
    /* bare "checkout" must be the first param — Shopify 400s on checkout=true
       and lands on the cart page if storefront=true precedes it */
    var url = window.location.origin + '/cart/' + items + '?checkout';
    if (code) url += '&discount=' + encodeURIComponent(code);
    window.location.href = url;
  };

  FishBundle.prototype.addViaAjax = function (counts, code) {
    var self = this;
    this.cta.classList.add('is-busy');
    var items = Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var chain = code
      ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      : Promise.resolve();
    chain.then(function () {
      return fetch(addUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
      });
    }).then(function (r) { return r.json(); }).then(function (res) {
      self.cta.classList.remove('is-busy');
      var html = res.sections && res.sections['cart-drawer'];
      var drawer = document.querySelector('cart-drawer');
      if (html && drawer) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('cart-drawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          /* adopt the fresh root classes too — a stale is-empty from initial
             page load blanks the whole drawer */
          drawer.className = fresh.className;
        }
        drawer.classList.remove('is-empty');
        drawer.classList.add('active', 'animate');
        document.body.classList.add('overflow-hidden');
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () {
      self.cta.classList.remove('is-busy');
      window.location.href = '/cart';
    });
  };

  if (!customElements.get('fish-bundle')) customElements.define('fish-bundle', FishBundle);

  /* ---------------- sticky bar ---------------- */

  function FishStickyBar() { return Reflect.construct(HTMLElement, [], FishStickyBar); }
  FishStickyBar.prototype = Object.create(HTMLElement.prototype);
  FishStickyBar.prototype.constructor = FishStickyBar;

  FishStickyBar.prototype.connectedCallback = function () {
    var self = this;
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.btn = this.querySelector('[data-sticky-cta]');

    document.addEventListener('fish:bundle-state', function (e) {
      self.targetId = 'bundle-' + e.detail.sectionId;
      if (self.priceEl) self.priceEl.textContent = fmt(e.detail.total);
    });
    var bundleEl = function () {
      return document.getElementById(self.targetId) || document.querySelector('fish-bundle');
    };
    if (this.btn) {
      this.btn.addEventListener('click', function () {
        var b = bundleEl();
        if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    /* visible only once the shopper has scrolled PAST the bundle — hidden
       before and while the bundle is on screen */
    var b = document.querySelector('fish-bundle');
    if (b && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var passed = !en.isIntersecting && en.boundingClientRect.bottom < 0;
        self.classList.toggle('is-visible', passed);
      }, { threshold: 0 }).observe(b);
    }
  };

  if (!customElements.get('fish-sticky-bar')) customElements.define('fish-sticky-bar', FishStickyBar);

  /* ---------------- hero carousel dots ---------------- */

  function FishCarousel() { return Reflect.construct(HTMLElement, [], FishCarousel); }
  FishCarousel.prototype = Object.create(HTMLElement.prototype);
  FishCarousel.prototype.constructor = FishCarousel;

  FishCarousel.prototype.connectedCallback = function () {
    var track = this.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var markers = [];

    var dotsEl = this.querySelector('[data-dots]');
    if (dotsEl) {
      if (slides.length < 2) { dotsEl.hidden = true; }
      else {
        slides.forEach(function (slide, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Image ' + (i + 1));
          if (i === 0) d.classList.add('is-active');
          dotsEl.appendChild(d);
          markers.push(d);
        });
      }
    }
    var thumbsEl = this.querySelector('[data-thumbs]');
    if (thumbsEl) {
      var thumbs = Array.prototype.slice.call(thumbsEl.children);
      if (slides.length < 2) thumbsEl.hidden = true;
      thumbs.forEach(function (t) { markers.push(t); });
    }
    if (slides.length < 2) return;

    markers.forEach(function (m, mi) {
      var idx = mi % slides.length;
      m.addEventListener('click', function () {
        track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = slides.indexOf(en.target);
          markers.forEach(function (m, mi) {
            m.classList.toggle('is-active', mi % slides.length === idx);
          });
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  };

  if (!customElements.get('fish-carousel')) customElements.define('fish-carousel', FishCarousel);

  /* ---------------- lazy video proof ---------------- */

  function initSaveButton() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fish-save]'), function (btn) {
      var key = 'fish-saved:' + (btn.dataset.saveKey || 'save') + ':' + window.location.pathname;
      var saved = false;
      try { saved = localStorage.getItem(key) === '1'; } catch (e) {}
      var countEl = btn.querySelector('[data-count]');
      var base = countEl ? countEl.textContent.trim() : '';
      var baseInt = /^\d+$/.test(base) ? parseInt(base, 10) : null;
      var render = function () {
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        if (countEl && baseInt !== null) countEl.textContent = String(baseInt + (saved ? 1 : 0));
      };
      render();
      btn.addEventListener('click', function () {
        saved = !saved;
        try { localStorage.setItem(key, saved ? '1' : '0'); } catch (e) {}
        render();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaveButton);
  } else {
    initSaveButton();
  }

  function initCartOpen() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fish-cart-open]'), function (el) {
      el.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return; /* falls through to the /cart href */
        e.preventDefault();
        drawer.classList.add('active', 'animate');
        document.body.classList.add('overflow-hidden');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartOpen);
  } else {
    initCartOpen();
  }

  /* Original total (struck) + hide native Subtotal + shipping line */
  function initOriginalTotal() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var render = function () {
      var totals = drawer.querySelector('.cart-drawer__totals');
      if (!totals) return;
      var rows = Array.prototype.slice.call(
        totals.querySelectorAll('.cart-drawer__totals__row:not(.fish-original-total)'));
      var existing = totals.querySelector('.fish-original-total');
      if (rows.length < 2) { if (existing) existing.remove(); return; }
      var amt = function (row) {
        var m = row.querySelector('.cart-drawer__totals__row__money');
        return m ? parseFloat((m.textContent || '').replace(/[^0-9.]/g, '')) || 0 : 0;
      };
      var savingsRow = rows[0], total = 0;
      rows.forEach(function (r) { total += amt(r); });
      /* currency symbol from the subtotal (last) row — the savings row's
         leading minus sign would match first otherwise */
      var lastMoney = rows[rows.length - 1].querySelector('.cart-drawer__totals__row__money');
      var cur = ((lastMoney ? lastMoney.textContent : '$').match(/[^\d.,\s-]/) || ['$'])[0];
      var val = cur + total.toFixed(2);
      if (existing && existing.dataset.v === val) return;
      if (!existing) {
        existing = document.createElement('p');
        existing.className = 'cart-drawer__totals__row fish-original-total';
        totals.insertBefore(existing, savingsRow);
      }
      existing.dataset.v = val;
      existing.innerHTML = '<span>Original total</span>' +
        '<span class="cart-drawer__totals__row__money">' + val + '</span>';
    };
    new MutationObserver(function () { requestAnimationFrame(render); })
      .observe(drawer, { childList: true, subtree: true });
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOriginalTotal);
  } else {
    initOriginalTotal();
  }

  function initNavDrawer() {
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!drawer) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nav-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavDrawer);
  } else {
    initNavDrawer();
  }

  function initReveals() {
    var els = document.querySelectorAll('.fish-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveals);
  } else {
    initReveals();
  }

  function initClips() {
    var clips = document.querySelectorAll('video.fish-clip[data-src]');
    if (!clips.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src) v.src = v.dataset.src;
          v.play().catch(function () {});
        } else if (v.src) {
          v.pause();
        }
      });
    }, { rootMargin: '200px' });
    Array.prototype.forEach.call(clips, function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClips);
  } else {
    initClips();
  }
})();
